/* global modeoL10n */

import 'es6-promise/auto';
import Vue from 'vue';
import Vuex from 'vuex';
import VueDraggable from 'vue-draggable';
import VueAwesomeSwiper from 'vue-awesome-swiper';
import AirbnbStyleDatepicker from 'vue-airbnb-style-datepicker';
import moment from 'moment';
import VueSanitize from 'vue-sanitize';
import VueLazyload from 'vue-lazyload';

import ProductSelections from './components/product/product-selections.vue';
import CartSummary from './components/cart/cart-summary.vue';
import ProductSection from './components/product/product-section.vue';
import ProductDetails from './components/product/product-details.vue';
import ProductCarousel from './components/product/product-carousel.vue';
import ProductImageCarousel from './components/product/product-image-carousel.vue';
import SaleFlash from './components/product/sale-flash.vue';
import ProductSticker from './components/product/product-sticker.vue';
import Cart from './components/cart/cart.vue';
import CartProductSearch from './components/cart/cart-product-search.vue';
import CheckoutSummary from './components/checkout/checkout-summary.vue';
import CheckoutOfferSummary from './components/checkout/checkout-offer-summary.vue';
import ImageCarousel from './components/image-carousel.vue';
import ProductTeaser from './components/product/product-teaser.vue';
import ProductTeaserBig from './components/product/product-teaser-big.vue';
import ProductContentLoader from './components/product/product-content-loader.vue';
import ProductSearch from './components/product/product-search.vue';
import ProductAddOns from './components/product/product-add-ons.vue';
import ProductMandatoryAddOns from './components/product/product-mandatory-add-ons.vue';
import ProductVariations from './components/product/product-variations.vue';
import Notification from './components/notification.vue';
import Subnavigation from './components/subnavigation.vue';
import CheckoutCustomerForm from './components/checkout/checkout-customer-form.vue';
import CheckoutAddressForm from './components/checkout/checkout-address-form.vue';
import CheckoutShippingMethod from './components/checkout/checkout-shipping-method.vue';
import CheckoutPaymentMethod from './components/checkout/checkout-payment-method.vue';
import CheckoutOfferDetails from './components/checkout/checkout-offer-details.vue';
import CheckoutOffersClientForm from './components/checkout/checkout-offers-client-form.vue';
import ConversionRfp from './components/checkout/conversion-rfp.vue';
import RegistrationForm from './components/registration-form.vue';
import FormValidations from './form-validations.js';
import OfferCart from './components/cart/offer-cart.vue';
import OfferActionsMenu from './components/offer-actions-menu.vue';
import Offers from './components/offers.vue';
import Price from './components/price.vue';
import VatToggle from './components/vat-toggle.vue';

new FormValidations(Vue);

const datepickerOptions = {
    daysShort: ['Ma', 'Ti', 'Ke', 'To', 'Pe', 'La', 'Su'],
    monthNames: ['Tammikuu', 'Helmikuu', 'Maaliskuu', 'Huhtikuu', 'Toukokuu', 'Kesäkuu', 'Heinäkuu', 'Elokuu', 'Syyskuu', 'Lokakuu', 'Marraskuu', 'Joulukuu'],
}

Vue.use(Vuex);
Vue.use(VueDraggable);
Vue.use(AirbnbStyleDatepicker, datepickerOptions);
Vue.use(VueAwesomeSwiper, {});
const defaultOptions = {
    allowedTags: [
        'strong',
        'b',
        'a',
        'span',
        'p',
        'h1',
        'h2',
        'h3',
        'h4',
        'h5',
        'ul',
        'ol',
        'li',
        'br',
    ],
};
Vue.use(VueSanitize, defaultOptions);
Vue.use(VueLazyload, {
    observer: true,
});

import _ from 'lodash';

Vue.config.ignoredElements = ['klarna-placement']

const store = new Vuex.Store({
    state: {
        totals: {},
        coupons: [],
        billingAddress: {},
        shippingAddress: {},
        paymentMethod: false,
        shippingMethod: false,
        shippingMethods: {},
        checkoutSubmitClicked: false,
        cartDeliveryTime: null,
        offerdetails: {},
        totalIncludingShipping: null,
        totalIncludingShippingWithoutTax: null,
        cartContents: [],
        allProductsAreInOutlet: false,
        totalCostPrice: 0,
        customer: false,
        productIncludesTaxes: false,
        cartIncludesTaxes: false,
        pricesIncludeTaxes: false,
        showPricesWithVat: true,
        vatPercentage: 1.24,
        orderType: 'order',
        changesAllowed: true,
        termsAndConditions: false,
    },
    getters: {
        getTotals: (state) => {
            return state.totals;
        },
        getCoupons: (state) => {
            return state.coupons;
        },
        getBillingAddress: (state) => {
            return state.billingAddress;
        },
        getShippingAddress: (state) => {
            return state.shippingAddress;
        },
        getPaymentMethod: (state) => {
            return state.paymentMethod;
        },
        getShippingMethod: (state) => {
            return state.shippingMethod;
        },
        getShippingMethods: (state) => {
            return state.shippingMethods;
        },
        getCheckoutSubmitClicked: (state) => {
            return state.checkoutSubmitClicked;
        },
        getCartDeliveryTime: (state) => {
            return state.cartDeliveryTime;
        },
        getOfferDetails: (state) => {
            return state.offerdetails;
        },
        getTotalIncludingShipping: (state) => {
            return state.totalIncludingShipping;
        },
        getTotalIncludingShippingWithoutTax: (state) => {
            return state.totalIncludingShippingWithoutTax;
        },
        getCartContents: (state) => {
            return state.cartContents;
        },
        getAllProductsAreInOutlet: (state) => {
            return state.allProductsAreInOutlet;
        },
        getTotalCostPrice: (state) => {
            return state.totalCostPrice;
        },
        getCustomer: (state) => {
            return state.customer;
        },
        getVatPercentage: (state) => {
            return state.vatPercentage;
        },
        showPricesWithVat: (state) => {
            return state.showPricesWithVat;
        },
        getCartIncludesTaxes: (state) => {
            return state.cartIncludesTaxes;
        },
        getProductIncludesTaxes: (state) => {
            return state.productIncludesTaxes;
        },
        getPricesIncludeTaxes: (state) => {
            return state.pricesIncludeTaxes;
        },
        displayVat: (state) => {
            return state.showPricesWithVat ? '24%' : '0%';
        },
        getOrderType: (state) => {
            return state.orderType;
        },
        isOrder: (state) => {
            return state.orderType === 'order';
        },
        isOffer: (state) => {
            return state.orderType === 'offer';
        },
        changesAllowed: (state) => {
            return state.changesAllowed;
        },
        getTermsAndConditions: (state) => {
            return state.termsAndConditions;
        },
    },
    mutations: {
        setTotals(state, payload) {
            state.totals = payload;
            store.commit('setTotalIncludingShipping', state);
        },
        setTotalIncludingShipping(state) {
            //update total including shipping
            let totalIncludingShipping =
                parseCommaDecimalFormat(state.totals.subtotal) +
                parseCommaDecimalFormat(state.totals.subtotalTax);
            let totalIncludingShippingWithoutTax = parseCommaDecimalFormat(
                state.totals.subtotal
            );

            // subtract discount
            if (state.totals.discount) {
                totalIncludingShipping -= parseCommaDecimalFormat(state.totals.discount + state.totals.discountTax);
                totalIncludingShippingWithoutTax -= parseCommaDecimalFormat(state.totals.discount);
            }

            // add shipping
            if (state.shippingMethod) {
                totalIncludingShipping += parseCommaDecimalFormat(
                    state.shippingMethod.cost_with_tax
                );
                totalIncludingShippingWithoutTax += parseCommaDecimalFormat(
                    state.shippingMethod.cost
                );
            }
            state.totalIncludingShipping = totalIncludingShipping;
            state.totalIncludingShippingWithoutTax = totalIncludingShippingWithoutTax;
        },
        setCoupons(state, payload) {
            state.coupons = payload;
        },
        setBillingAddress(state, payload) {
            state.billingAddress = payload;
        },
        setShippingAddress(state, payload) {
            state.shippingAddress = payload;
        },
        setPaymentMethod(state, payload) {
            state.paymentMethod = payload;
        },
        setShippingMethod(state, payload) {
            state.shippingMethod = payload;
            store.commit('setTotalIncludingShipping', state);
        },
        setShippingMethods(state, payload) {
            state.shippingMethods = payload;

            //update selected shipping method
            let selectedShippingMethodID = state.shippingMethod ? state.shippingMethod.id : undefined;

            state.shippingMethod = state.shippingMethods[selectedShippingMethodID];
        },
        setCheckoutSubmitClicked(state, payload) {
            state.checkoutSubmitClicked = payload;
        },
        setCartDeliveryTime(state, payload) {
            state.cartDeliveryTime = payload;
        },
        setOfferDetails(state, payload) {
            state.offerdetails = payload;
        },
        setCartContents(state, payload) {
            state.cartContents = payload;
            let allProductsAreInOutlet = true;
            let baseCostPrice = 0;

            for (let i = 0; i < state.cartContents.length; i++) {
                // outlet
                if (state.cartContents[i].outlet == false) {
                    allProductsAreInOutlet = false;
                    break;
                }
            }

            // base product cost price
            baseCostPrice = _.sumBy(state.cartContents, function (item) {
                if (!item.cost_price || item.is_alternative) {
                    return 0;
                }

                item.cost_price = parseCommaDecimalFormat(item.cost_price);
                let unitCostPrice = isNaN(item.cost_price) ? 0 : item.cost_price;
                return unitCostPrice * parseInt(item.quantity);
            });

            state.totalCostPrice = baseCostPrice;
            state.allProductsAreInOutlet = allProductsAreInOutlet;
        },
        startToLoadNewItem(state, payload = false) {
            let cartContents = _.clone(state.cartContents);
            if (payload === false) {
                cartContents.push({ loading: true });
            } else {
                cartContents.splice(payload, 0, { loading: true });
            }
            state.cartContents = cartContents;
        },
        setCustomer(state, payload) {
            state.customer = payload;
        },
        setCartIncludesTaxes(state, payload) {
            state.cartIncludesTaxes = payload;
        },
        setProductIncludesTaxes(state, payload) {
            state.productIncludesTaxes = payload;
        },
        setPricesIncludeTaxes(state, payload) {
            state.pricesIncludeTaxes = payload;
        },
        setShowPricesWithVat(state, payload) {
            if (state.orderType === 'offer') {
                payload = false;
            }
            sessionStorage.showPricesWithVat = payload;
            state.showPricesWithVat = payload;
        },
        setOrderType(state, payload) {
            state.orderType = payload;
        },
        setChangesAllowed(state, payload) {
            state.changesAllowed = payload;
        },
        setTermsAndConditions(state, payload) {
            state.termsAndConditions = payload;
        },
    },
});

Vue.filter('formatPrice', function (price) {
    const formattedPrice = parseCommaDecimalFormat(price).toFixed( 2 ).toString();
    if (modeoL10n.lang == 'en') {
        return '€' + formattedPrice.replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    } else {
        return formattedPrice.replace(/\B(?=(\d{3})+(?!\d))/g, ' ').replace('.', ',') + ' €';
    }
});

Vue.filter('formatIntPrice', function (price) {
    const formattedPrice = parseCommaDecimalFormat(price).toFixed(0).toString();

    if (modeoL10n.lang == 'en') {
        return '€' + formattedPrice.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    } else {
        return formattedPrice.replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' €';
    }
});

Vue.filter('formatPercent', function (percent) {
    if (isNaN(percent)) {
        return '-';
    }
    const formattedPercent = parseCommaDecimalFormat(percent).toFixed().toString();
    return formattedPercent.replace('.', ',');
});

Vue.filter('formatDate', function (date) {
    let dateObj = moment(String(date));

    return dateObj.isValid() ? dateObj.format('DD.MM.YYYY') : '-';
});

Vue.filter('formatString', function (format, arg) {
    return format.replace('%1$s', arg);
});

Vue.prototype.forceFloat = function() {
    if ( !Number.isInteger( parseInt( event.key ) ) && event.key !== ',' ) {
        event.preventDefault();
    } else {
        return true;
    }
};

const parseCommaDecimalFormat = function( number ) {
    if ( typeof number === 'undefined' ) {
        return 0;
    } else if ( typeof number === 'number' ) {
        return number;
    } else if ( typeof number === 'string' ) {
        number = number.replace( ',', '.' );
        return parseFloat( number );
    }
    return 0;
}

Vue.prototype.parseCommaDecimalFormat = parseCommaDecimalFormat;

const toCommaDecimalFormat = function( number ) {
    if ( typeof number === 'undefined' ) {
        return 0;
    }
    if ( typeof number === 'number' ) {
        return number.toString().replace( '.', ',' );
    } else if ( typeof number === 'string' ) {
        return number.replace( '.', ',' );
    }
    return 0;
};
Vue.prototype.toCommaDecimalFormat = toCommaDecimalFormat;

Vue.prototype.$modeoL10n = modeoL10n;

Vue.component('Price', Price);

new Vue({
    el: '#site-wrapper',
    store,
    _,
    components: {
        ProductImageCarousel,
        ProductSelections,
        CartSummary,
        ProductSection,
        ProductDetails,
        ProductCarousel,
        SaleFlash,
        ProductSticker,
        Cart,
        CartProductSearch,
        OfferCart,
        Offers,
        OfferActionsMenu,
        CheckoutSummary,
        CheckoutOfferSummary,
        CheckoutAddressForm,
        CheckoutCustomerForm,
        CheckoutShippingMethod,
        CheckoutPaymentMethod,
        CheckoutOfferDetails,
        CheckoutOffersClientForm,
        ConversionRfp,
        ImageCarousel,
        ProductTeaser,
        ProductTeaserBig,
        ProductContentLoader,
        ProductSearch,
        ProductAddOns,
        ProductMandatoryAddOns,
        ProductVariations,
        Notification,
        Subnavigation,
        RegistrationForm,
        Price,
        VatToggle,
    },
});
